import { t } from "@lingui/macro"
import { useMemo } from "react"

import { IPublicConversationItem } from "./public-conversation-item"

import { NoWrap } from "src/components/NoWrap"
import { RowCellContainer } from "src/components/RowCellContainer"
import { TableChipCell } from "src/components/TableChipCell"
import { Time } from "src/components/Time"
import { IColumn } from "src/types/data-grid-pro"
import { parseStatus } from "src/types/chatbot"
import { ChatbotStatusChip } from "src/views/chatbot/components/ChatbotChip"
import { FadedRowCellContainer } from "src/views/chatbot/styles"
import { chatbotConversationsConstants } from "src/views/chatbot/constants"

export const useGetPublicConversationColumns = (
    tagsValueOptions: { label: string; value: number | undefined }[],
): IColumn<IPublicConversationItem>[] => {
    return useMemo(
        () => [
            {
                field: "conversation_id",
                headerName: t`chatbot-view.list.conversation-id`,
                description: t`chatbot-view.list.conversation-id-description`,
                renderCell: (params) => (
                    <RowCellContainer>{params.value}</RowCellContainer>
                ),
                type: "string",
                sortable: false,
                minWidth: 250,
            },
            {
                field: "created_at",
                headerName: t`chatbot-view.list.start-date`,
                description: t`chatbot-view.list.start-date-description`,
                minWidth: 110,
                renderCell: (params) => <Time date={params.value} />,
                type: "dateTime",
            },
            {
                field: "tags",
                headerName: t`chatbot-view.list.tags`,
                description: t`chatbot-view.list.tags-description`,
                renderCell: (params) => (
                    <TableChipCell
                        value={params.value}
                        label={t`tags-cell-component.tags`.toLowerCase()}
                    />
                ),
                type: "singleSelect",
                // @ts-ignore
                valueOptions: tagsValueOptions,
                sortable: false,
            },
            {
                field: "user_feedback_thumb_status",
                headerName: t`chatbot-view.list.end-user-feedback`,
                description: t`chatbot-view.list.end-user-feedback-description`,
                renderCell: (params) =>
                    params.value !== -1 ? (
                        <NoWrap>
                            <ChatbotStatusChip
                                status={
                                    params.value === 1
                                        ? parseStatus("positive")
                                        : parseStatus("negative")
                                }
                            />
                        </NoWrap>
                    ) : (
                        <FadedRowCellContainer>
                            {parseStatus("unknown")}
                        </FadedRowCellContainer>
                    ),
                type: "singleSelect",
                // @ts-ignore
                valueOptions:
                    chatbotConversationsConstants.feedbackThumbStatusOptions,
                sortable: false,
            },
            {
                field: "admin_feedback_thumb_status",
                headerName: t`chatbot-view.list.admin-feedback`,
                description: t`chatbot-view.list.admin-feedback-description`,
                renderCell: (params) =>
                    params.value !== -1 ? (
                        <NoWrap>
                            <ChatbotStatusChip
                                status={
                                    params.value === 1
                                        ? parseStatus("positive")
                                        : parseStatus("negative")
                                }
                            />
                        </NoWrap>
                    ) : (
                        <FadedRowCellContainer>
                            {parseStatus("unknown")}
                        </FadedRowCellContainer>
                    ),
                type: "singleSelect",
                // @ts-ignore
                valueOptions:
                    chatbotConversationsConstants.feedbackThumbStatusOptions,
                sortable: false,
            },
        ],
        [tagsValueOptions],
    )
}
